import { find, get } from 'lodash';
import { useSite } from './use-site';
import { usePages } from './use-pages';
import { useEnv } from './use-env';
export var useHomePage = function () {
  var site = useSite();
  var allPages = usePages() || [];
  var env = useEnv();
  var slug = get(site, 'homePage.slug', env.HOME_PAGE_SLUG || '');
  if (slug) {
    var page = find(allPages, function (page) {
      return page.slug === slug;
    });
    return page;
  }
  return null;
};